import { createLoadingScreen } from "./ElementsCreator";

export default class Loader {
	private static loader: HTMLElement = createLoadingScreen();

	public static show() {
		document.body.appendChild(this.loader);
	}

	public static hide() {
		this.loader.remove();
	}
}
